import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'x-item-not-found',
  templateUrl: './item-not-found.component.html',
  styleUrls: ['./item-not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemNotFoundComponent {
  @Input() heading: string = 'Oops! Item not found';
  @Input() alignment: 'left' | 'right' | 'center' = 'center';
  @Input() subHeading: string = 'The item you were looking for no longer exists.';

  get bodyAlignment() {
    switch (this.alignment) {
      case 'left':
        return 'start';
      case 'right':
        return 'end';
      default:
        return this.alignment;
    }
  }
}
